import { Deserializable } from '../protocols/deserializable';
import { AnnuitySplitReasonAvailability } from './annuity-split-reason-availability';

export class AnnuityPensionAccountPaymentInstructionAvailableActions implements Deserializable {
  public canAct!: boolean;
  public canSplit!: boolean;
  public canSuspend!: boolean;
  public canResume!: boolean;
  public canTerminate!: boolean;
  public splitReasons!: AnnuitySplitReasonAvailability[];

  public onDeserialize(): void {}
}
